import { stringifyFptiProps } from '@/utils'
import { commonProperties } from '../../fpti'

export const EDIT_PROFILE_TERMS_LINK_CLICK_FPTI = stringifyFptiProps({
  ...commonProperties,
  eventName: 'bp_profile_preview_page_terms_link_click',
})

export const EDIT_PROFILE_AGREE_AND_PUBLISH_CLICK_FPTI = stringifyFptiProps({
  ...commonProperties,
  eventName: 'bp_profile_preview_page_publish_click',
})

export const EDIT_PROFILE_PUBLISH_SUCCESS_FPTI = {
  ...commonProperties,
  eventName: 'edit_bp_publish_profile_success',
}

export const EDIT_PROFILE_PUBLISH_ERROR_FPTI = {
  ...commonProperties,
  eventName: 'edit_bp_publish_profile_failure',
}
